<template>
  <button
    :type="type || 'button'"
    :class="btnClass"
    @click="$emit('click', $event)" >
      <slot></slot>
  </button>
</template>

<script>
import BtnTypes from '@/constants/BtnTypes'

export default {
  name: 'Button',
  props: [
    'styleType',
    'type',
    'click'
  ],
  computed: {
    btnClass () {
      switch (this.styleType) {
        case BtnTypes.ORANGE_GRADIENT:
          return ''
        case BtnTypes.ORANGE_BKG_DARK_TXT:
          return 'btn-type-4'
        case BtnTypes.TRANSPARENT_BKG_GRAY_TXT:
          return 'btn-type-4'
        case BtnTypes.RED_BKG_WHITE_TXT:
          return ''
        case BtnTypes.YELLOW_BKG_WHITE_TXT:
          return ''
        case BtnTypes.BLUE_BKG_WHITE_TXT:
          return ''
        case BtnTypes.GREEN_BKG_WHITE_TXT:
          return ''
        case BtnTypes.RED_BORDER_WHITE_TEXT:
          return 'btn btn-white-text btn-transparent-bkg btn-border-red'
        case BtnTypes.YELLOW_BORDER_WHITE_TEXT:
          return 'btn btn-white-text btn-transparent-bkg btn-border-yellow'
        case BtnTypes.BLUE_BORDER_WHITE_TEXT:
          return 'btn btn-white-text btn-transparent-bkg btn-border-blue'
        case BtnTypes.GREEN_BORDER_WHITE_TEXT:
          return 'btn btn-white-text btn-transparent-bkg btn-border-purple btn-perspective-hover'
        default:
          return 'btn'
      }
    }
  }
}
</script>
